/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { withFormik } from 'formik'
/** @todo No @types for yup so have to require over import to skip TSC */
const Yup = require('yup')
import onClickOutside from 'react-onclickoutside'

/**
 *     Import
 *     - Components
 */
import { Button } from '../../../common/Button/Button'
import { Alert } from '../../../common/Alert/Alert'
import { Dropdown } from '../../../common/Dropdown/Dropdown'
import { PlusIcon } from '../../../../images/icons/Plus/Plus'
import { BinIcon } from '../../../../images/icons/Bin/Bin'
import AddressLookup from '../../../../containers/common/Address/Address'
import CompanyLookup from '../../../common/Company/CompanyLookup'
import Checkbox from '../../../common/Checkbox/Checkbox'
import * as moment from 'moment'
import { DateInput } from '../../../common/DateInput'
import { InfoIcon } from '../../../../images/icons/Info/Info'
import { SearchSelect } from '../../../common/SearchSelect/SearchSelect'
/**
 * This will make a wrapper outside the Dropdown component to handle
 * the outside clicks
 */
var EnhancedComponent = onClickOutside(Dropdown)
var EnhancedSearchComponent = onClickOutside(SearchSelect)
var getCollectorsPolicyTypesId = 0
var getMuseumsPolicyTypesId = 0
var getDealerStockPolicyTypesId = 0
var checkIsCollectors = false
var checkIsMuseums = false
var checkIsDealersStock = false
var checkCountryUk = false
var clientType = ''
/**
 * Set title list
 */
const titleList = [
    { value: 'mr', text: 'Mr' },
    { value: 'mrs', text: 'Mrs' },
    { value: 'miss', text: 'Miss' },
    { value: 'ms', text: 'Ms' },
    { value: 'sir', text: 'Sir' },
    { value: 'dr', text: 'Dr' },
]

/**
 * Set client type list
 */
const clientTypeList = [
    { value: 'individual', text: 'Individual' },
    { value: 'limited-company', text: 'Limited Company' },
    { value: 'sole-trader', text: 'Other Entity' },
]

const clientTypeListMuseums = [
    { value: 'limited-company', text: 'Limited Company' },
    { value: 'sole-trader', text: 'Other Entity' },
]

/**
 * Set client type list
 */
const addressTypeList = [
    { value: 'home', text: 'Home' },
    { value: 'office', text: 'Office' },
    // { value: 'storage location', text: 'Storage' },
]

/**
 * Form HTML
 *
 * @class Step00FormHTML
 * @extends {React.Component<any, any>}
 */
class Step00FormHTML extends React.Component<any, any> {

    /**
     * Creates an instance of Step00FormHTML.
     * @param {*} props
     * @memberof Step00FormHTML
     */
    constructor(props: any) {
        super(props)
        this.state = {
            clientNames: [{ title: '', firstName: '', surname: '', dateOfBirth: null }],
            clientTypeSelected: '',
            policyTypeSelected: null,
            policyCategorySelected: null,
            isCollectorPolicyConfirmed: false,
            isUK: false,
            showPolicyType: true,
            checkCountrySelect: false,
        }
    }
    /**
     * Will fetch all the policy types before mounting the component
     *
     * @memberof Step00FormHTML
     */
    componentWillMount() {
        this.props.address.getAddress.response = []
        this.props.address.findAddress.response = []
        this.props.address.getLatLong.response = []
        this.props.fetchPolicyCategories()
        this.props.fetchPolicyTypes()
        this.props.fetchCountries()
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>): void {
        const {
            policyCategories,
            policyTypes,
        } = this.props
        if (
            policyCategories.data.length !== prevProps.policyCategories.data.length &&
            policyCategories.data.length > 0
        ) {
            this.setState({ policyCategorySelected: policyCategories.data[0].policyCategoryId })
        }
        if (
            policyTypes.data.length !== prevProps.policyTypes.data.length &&
            policyTypes.data.length > 0
        ) {
            this.setState({ policyTypeSelected: policyTypes.data[0].policyTypeId })
        }
        if (policyTypes && policyTypes.data.length === 0 && !policyTypes.isLoading) {
            let data = {
                policyTypeId: 1,
                title: 'Art and Antiques Dealer',
                groupTitle: 'Art and Antiques',
                subTitle: 'Dealers',
                customTitle: false,
            }
            policyTypes.data.push(data)
            this.setState({ policyTypeSelected: policyTypes.data[0].policyTypeId, showPolicyType: false })
        }
    }

    /**
     * Reset all quote data before going to next step
     *
     * @memberof Step00FormHTML
     */
    componentWillUnmount() {
        if (this.props.resetQuotes) {
            this.props.resetQuotes()
        }
    }

    /**
     * Dynamic Field group
     * Set the values on component state.
     * After changing it on the component state, call setFieldValue() to set the values on the form
     *
     * @param  {integer} index [row index]
     * @param  {string} value [Text value to be updated]
     * @param  {string} field [Name of the field to be updated]
     */
    handleDynamicChange = (index, value = '', field = '') => {

        const newClientNames = this.state.clientNames.map((client, sidx) => {

            if (index !== sidx) { return client }

            switch (field) {
                case 'title': return { ...client, title: value }
                case 'firstName': return { ...client, firstName: value }
                case 'surname': return { ...client, surname: value }
                case 'dateOfBirth': return { ...client, dateOfBirth: value }
                default: return { ...client }
            }

        })

        this.setState({ clientNames: newClientNames })
        this.props.setFieldValue('clientNames', newClientNames)
    }

    /**
     * Dynamic Field group
     * Input text fields onChange trigger call this function
     * handleDynamicChange() is called to help setting the values on component state.
     *
     * @param  {integer} index [row index]
     */
    handleDynamicValueChange = (index) => (event) => {
        this.handleDynamicChange(index, event.target.value, event.target.name)
    }

    /**
     * Dynamic Field group
     * Dropdown fields onChange trigger call this function
     * handleDynamicChange() is called to help setting the values on component state.
     *
     * @param  {integer} index [row index]
     * @param  {string} value [Text value to be updated]
     */
    handleDynamicSelect = (index, value) => {
        this.handleDynamicChange(index, value, 'title')
    }

    /**
     * Dynamic Field group
     * Handle the Add new row action request
     * After changing it on the component state, call setFieldValue() to set the values on the form
     */
    handleDynamicAdd = () => {
        let added = this.state.clientNames.concat([{ title: '', firstName: '', surname: '', dateOfBirth: null }])
        this.setState({
            clientNames: added,
        })
        this.props.setFieldValue('clientNames', added)
    }

    /**
     * Dynamic Field group
     * Handle the remove row
     * After changing it on the component state, call setFieldValue() to set the values on the form
     *
     * @param  {integer} idx [row index]
     */
    handleDynamicRemove = (index) => () => {
        let removed = this.state.clientNames.filter((s, sidx) => index !== sidx)
        this.setState({
            clientNames: removed,
        })
        this.props.setFieldValue('clientNames', removed)
    }

    /**
     * On focus set Label element with class 'active'
     */
    focusChange = (event: any) => {
        if (event.target.classList.contains('calendar__input')) {
            event.target.parentNode.parentNode.previousSibling.classList = 'active'
        } else {
            event.target.previousSibling.classList = 'active'
        }
    }

    /**
     * Manage the client type dropdown changes
     */
    policyTypeListChange = (name: any, value: any) => {
        this.setState({ policyTypeSelected: value })
        this.props.setFieldValue(name, value)
    }

    policyCategoryListChange = (name: string, value: number, policyCategories: any[]) => {
        const policyCategory = policyCategories.find(category => category.policyCategoryId === value)
        this.setState({
            policyCategorySelected: value,
            isUK: false,
        })
        this.props.setFieldValue(name, value)
        this.props.setFieldValue('isCollectors', policyCategory.isCollectors)
        this.props.setFieldValue('isMuseums', policyCategory.isMuseums)
        this.props.setFieldValue('isDealersStock', policyCategory.isDealersStock)
        checkIsCollectors = policyCategory.isCollectors
        checkIsMuseums = policyCategory.isMuseums
        checkIsDealersStock = policyCategory.isDealersStock
        if (!policyCategory.isCollectors || !policyCategory.isMuseums || !policyCategory.isDealersStock) {
            this.props.setFieldValue('countryId', null)
        }
    }

    getAddressTypes = (isCollectors: boolean, isMuseums: boolean): any[] => {
        // if (!isCollectors) {
        //     return [...addressTypeList, { value: 'retail location', text: 'Retail' }]
        // }
        if (isMuseums) {
            return [{ value: 'museums', text: 'Museums' }]
        }
        return addressTypeList
    }

    /**
     * Handle the Collectors checkbox
     */
    handleCheckbox = (state: any, name: any) => {
        this.props.setFieldValue(name, state)
        this.setState({ isCollectorPolicyConfirmed: state })
    }

    /**
     * Change value when policyNameChange changes
     */
    policyNameChange = (value: any) => this.props.setFieldValue('policyName', value)

    /**
     * On calendar date is selected
     */
    calendarChange = (index) => (date) => {
        this.handleDynamicChange(index, date, 'dateOfBirth')
    }

    /**
     * Change Formik value when tradingNameChange changes
     */
    tradingNameChange = (value: any) => this.props.setFieldValue('tradingName', value)

    /**
     * Manage the client type dropdown changes
     */
    clientTypeListChange = (name: any, value: any) => {
        this.setState({ clientTypeSelected: value })
        this.props.setFieldValue(name, value)
        clientType = value
        this.changeBusinessName('', '')
    }

    /**
     * Changes the address in the Formik values array
     *
     * @param {*} name
     * @param {*} value
     * @memberof Step00FormHTML
     */
    addressChange = (name: any, value: any) => this.props.setFieldValue(name, value)

    /**
     * It will update the Formik values businessId and
     * businessName
     *
     * @param {string} companyId
     * @param {string} companyName
     * @memberof Step00FormHTML
     */
    changeBusinessName = (companyId: string, companyName: string) => {
        this.props.setFieldValue('businessId', companyId)
        this.props.setFieldValue('businessName', companyName)
        this.forceUpdate()
    }

    handleTextualDateInputChange = (idx, date) => {
        this.calendarChange(idx)(date)
    }

    handleSubmitClick = () => {
        window.scrollTo(0, 0)
    }

    handleCountrySelect = (name: string, value: number) => {
        const currentCountry = this.props.countries.data.find(country => country.id === value)
        this.setState({ isUK: currentCountry.name.toUpperCase() === 'UK', checkCountrySelect: true })
        checkCountryUk = (currentCountry.name.toUpperCase() === 'UK')
        this.props.setFieldValue(name, value)
        this.changeBusinessName('', '')
    }

    mapPolicyCategoriesToDropdownList = (policyCategories) => {
        return policyCategories.map(category => ({
            value: category.policyCategoryId,
            text: category.title,
        }))
    }

    mapPolicyTypesToDropdownList = (policyTypes) => {
        return policyTypes.map(type => ({
            value: type.policyTypeId,
            text: type.subTitle,
        }))
    }

    mapCountriesToDropdownList = (countries) => {
        return countries
            .filter(country => country.clientsAccepted)
            .map(country => ({
                value: country.id,
                text: country.name,
            }))
    }

    render() {
        const {
            handleSubmit,
            setFieldValue,
            policyCategories,
            policyTypes,
            countries,
            values,
        } = this.props
        const {
            policyCategorySelected,
            policyTypeSelected,
            isUK,
            checkCountrySelect,
        } = this.state
        if (
            !policyCategories.data.length ||
            !policyTypes.data.length ||
            !countries.data.length ||
            !policyCategorySelected ||
            !policyTypeSelected
        ) {
            return null
        }

        if (this.props.quote.step00.done && !this.props.quote.step00.loading) {
            this.props.history.push(`/quote/${this.props.quote.step00.response.quote.id}/step01`)
        }

        let errorList: any[] = []

        let errorState: any = null // Fake errorState for test proposes
        if (errorState !== null) { errorList.push(errorState._data) }

        /**
         * Check if all fields have been filled
         */
        let allFilled = (Object.keys(this.props.errors).length === 0) ? false : true

        const policyCategory = policyCategories.data.find(
            category => category.policyCategoryId === policyCategorySelected
        )
        const policyCategoryDropdownList = this.mapPolicyCategoriesToDropdownList(policyCategories.data)
        const policyTypeDropdownList = this.mapPolicyTypesToDropdownList(policyTypes.data)
        const countryDropdownList = this.mapCountriesToDropdownList(countries.data)
        if (policyTypeDropdownList && policyTypeDropdownList.length !== 0) {
            policyCategoryDropdownList.map((l) => {
                if (l.text && ((l.text).toLowerCase()) === 'collectors') {
                    getCollectorsPolicyTypesId = l.value
                }

                if (l.text && ((l.text).toLowerCase()) === 'museums') {
                    getMuseumsPolicyTypesId = l.value
                }

                if (l.text && ((l.text).toLowerCase()) === 'dealers stock') {
                    getDealerStockPolicyTypesId = l.value
                }
            })
        }
        return (
            <div className="step00">

                {(!!Object.keys(this.props.errors).length && !!Object.keys(this.props.touched).length) && (
                    Object.keys(this.props.errors).filter(
                        (msg) => (Object.keys(this.props.touched).includes(msg) ||
                            msg.indexOf('clientNames') >= 0)
                    ).map((error, idx) => {
                        const msg = this.props.errors[error]
                        errorList.push(`${msg.charAt(0).toUpperCase()}${msg.slice(1)}`)
                    })
                )}

                {(errorList.length) ? (
                    <Alert type="error">
                        {errorList.map((a, i) => (<p key={i}>{a}</p>))}
                    </Alert>
                ) : null}

                {(this.props.quote.step00.error) ? (
                    <Alert type="error">
                        Error: something went wrong please contact support
                    </Alert>
                ) : null}

                <form onSubmit={handleSubmit} className="quote__form noOverflow">

                    <h4>Policy type</h4>

                    <div className="quote__form__group form__w40">
                        <EnhancedComponent
                            itemList={policyCategoryDropdownList}
                            name="policyCategoryId"
                            setFieldValue={
                                (name, value) => this.policyCategoryListChange(name, value, policyCategories.data)
                            }
                            selected={[
                                policyCategoryDropdownList[0].value,
                                policyCategoryDropdownList[0].text,
                            ]}
                            label="Choose policy"
                        />
                    </div>

                    {(!policyCategory.isCollectors && !policyCategory.isMuseums && !policyCategory.isDealersStock) ? (
                        /* zero = custom sub-type */
                        <div className="quote__form__group form__w40">
                            <EnhancedComponent
                                itemList={policyTypeDropdownList}
                                name="policyTypeId"
                                setFieldValue={this.policyTypeListChange}
                                selected={[
                                    policyTypeDropdownList[0].value,
                                    policyTypeDropdownList[0].text,
                                ]}
                            />
                        </div>
                    ) : policyCategory.isCollectors ? (
                        <div className="quote__form__group form__w60 address__checkbox step0-checkbox no-padding">
                            <Checkbox
                                name="isCollectorPolicyConfirmed"
                                onChange={this.handleCheckbox}
                            >
                                Please confirm that the policy holder is not a commercial entity
                                trading in art and antiques.
                            </Checkbox>
                        </div>
                    ) : null}

                    {(this.state.policyTypeSelected < 0) ? ( /* negative = custom title */
                        <div>
                            <div className="quote__form__group form__w50 top_margin">
                                <label>Policy Name</label>
                                <input
                                    name="policyName"
                                    placeholder="Policy Name"
                                    onFocus={this.focusChange}
                                    type="text"
                                    onChange={(event) => { this.policyNameChange(event.target.value) }}
                                />
                            </div>
                        </div>
                    ) : null}

                    {/* <div className="quote__form__group quote__form__group--calendar">
                         <label>Policy inception date</label>
                         <DatePicker
                             placeholder="Policy inception date"
                             onChange={this.calendarChange}
                             onFocus={this.focusChange}
                         />
                     </div> */}

                    <div className="quote__form__splitter" />

                    <h4>Client details</h4>

                    <div className="quote__form__group form__w40">
                        <EnhancedComponent
                            itemList={policyCategory.isMuseums ? clientTypeListMuseums : clientTypeList}
                            name="clientType"
                            setFieldValue={this.clientTypeListChange}
                            label="Client type"
                        />
                    </div>

                    {(this.state.clientTypeSelected === 'sole-trader') ? (
                        <div className="quote__form__group form__w60">
                            <label>Trading Name</label>
                            <input
                                name="tradingName"
                                placeholder="Trading Name"
                                onFocus={this.focusChange}
                                type="text"
                                onChange={(event) => { this.tradingNameChange(event.target.value) }}
                            />
                        </div>
                    ) : null}

                    <div className="quote__form__splitter" />

                    <h4>Client’s full name</h4>
                    <h5>If not a Limited company</h5>

                    <div className="quote__form__dynamicGroup">
                        {this.state.clientNames.map((clientNames, idx) => (
                            <div key={idx} className="quote__form__dynamic">

                                <div className="quote__form__group quote__form__dynamic--small">
                                    <label>Title</label>
                                    <EnhancedComponent
                                        itemList={titleList}
                                        name={idx}
                                        setFieldValue={this.handleDynamicSelect}
                                        label="Title"
                                    />
                                </div>

                                <div className="quote__form__group quote__form__dynamic--regular">
                                    <label>First name</label>
                                    <input
                                        name="firstName"
                                        placeholder="First name"
                                        onFocus={this.focusChange}
                                        type="text"
                                        onChange={this.handleDynamicValueChange(idx)}
                                    />
                                </div>

                                <div className="quote__form__group quote__form__dynamic--regular">
                                    <label>Surname</label>
                                    <input
                                        name="surname"
                                        placeholder="Surname"
                                        onFocus={this.focusChange}
                                        type="text"
                                        onChange={this.handleDynamicValueChange(idx)}
                                    />
                                </div>

                                <div className="quote__form__group quote__form__group--calendar step0">
                                    <label className="active">Date of birth <InfoIcon color={'#F07662'} /></label>
                                    <DateInput
                                        guide={true}
                                        placeholder="DD/MM/YYYY"
                                        onChange={(date) => this.handleTextualDateInputChange(idx, date)}
                                        showIcon={false}
                                    />
                                </div>

                                <button
                                    type="button"
                                    onClick={this.handleDynamicRemove(idx)}
                                    className="quote__form__dynamic--remove"
                                >
                                    <BinIcon color={'#F07662'} />
                                </button>
                            </div>
                        ))}
                    </div>

                    <button
                        type="button"
                        onClick={this.handleDynamicAdd}
                        className="quote__form__dynamic--add"
                    >
                        <PlusIcon /><span>Add additional client</span><PlusIcon />
                    </button>

                    <div className="quote__form__splitter" />

                    <h4>Address</h4>
                    <h5>Business address if limited company or home address if other entity;
                        this is used for Sanctions Searches.</h5>
                    <div className="address-group">
                        {this.props.address.findAddress.done &&
                            this.props.address.findAddress.response[0] &&
                            this.props.address.findAddress.response[0].Error ?
                            <Alert type="error">
                                Address look up failed; please enter address manually
                            </Alert> :
                            null}

                        <div className="quote__form__group form__w40">
                            <EnhancedComponent
                                itemList={this.getAddressTypes(policyCategory.isCollectors, policyCategory.isMuseums)}
                                name="addressType"
                                setFieldValue={setFieldValue}
                                label="Address type"
                            />
                        </div>

                        {
                            (policyCategory.isCollectors || policyCategory.isMuseums || policyCategory.isDealersStock) ?
                                <div className="quote__form__group form__w40">
                                    <EnhancedSearchComponent
                                        itemList={countryDropdownList}
                                        name="countryId"
                                        setFieldValue={this.handleCountrySelect}
                                        label="Country"
                                    />
                                </div>
                                : null
                        }

                        {
                            (!policyCategory.isCollectors &&
                                !policyCategory.isMuseums &&
                                !policyCategory.isDealersStock) ||
                                values.countryId ?
                                <AddressLookup
                                    findAddressTrigger={this.props.findAddress}
                                    getAddressTrigger={this.props.getAddress}
                                    getLatLongTrigger={this.props.getLatLong}
                                    address={this.props.address}
                                    setAddress={this.addressChange}
                                    isAddressLookupByTermShown={
                                        (!policyCategory.isCollectors &&
                                            !policyCategory.isMuseums && !policyCategory.isDealersStock) || isUK}
                                />
                                : null
                        }
                    </div>

                    {(this.state.clientTypeSelected === 'limited-company') ? (
                        <div className="quote__form__group form__w65">
                            <CompanyLookup
                                companyNameSearch={this.props.companyNameSearch}
                                companyNames={this.props.companyNames}
                                changeBusinessName={this.changeBusinessName}
                                checkCountrySelect={checkCountrySelect}
                                isUK={(policyCategory.isCollectors ||
                                    policyCategory.isMuseums ||
                                    policyCategory.isDealersStock) ? isUK : true}
                            />
                        </div>
                    ) : null}

                    <div className="quote__form__group quote__form__group--submit">
                        <Button
                            half={false}
                            type="submit"
                            onClick={this.handleSubmitClick}
                            disabled={allFilled}
                        >
                            Save and continue
                        </Button>
                    </div>

                </form>

            </div>
        )
    }
}

/**
 *     Formik Validation Struture
 */
const Step00Form = withFormik<any, any>({

    mapPropsToValues: (props: any) => {
        return ({
            policyCategoryId: '',
            policyTypeId: '',
            policyName: '',
            isCollectors: true,
            isMuseums: true,
            isCollectorPolicyConfirmed: false,
            // policyInceptionDate: '',
            clientType: '',
            businessName: '',
            tradingName: '',
            businessId: '',
            addressType: '',
            addressLine1: '',
            addressLine2: '',
            countryId: null,
            lat: '',
            lng: '',
            city: '',
            postcode: '',
            clientNames: [{ title: '', firstName: '', surname: '', dateOfBirth: null }],
        })
    },

    validationSchema: Yup.object().shape({
        // policyTypeId: Yup.number().required('Policy type is required'),
        policyTypeId: Yup.number().when('policyCategoryId', {
            is: value => value !== getCollectorsPolicyTypesId &&
                value !== getMuseumsPolicyTypesId &&
                value !== getDealerStockPolicyTypesId,
            then: Yup.number().required('Policy type is required'),
            otherwise: Yup.number().default(1),
        }),
        policyCategoryId: Yup.number().required('Policy category is required'),
        policyName: Yup.string().when('policyTypeId', {
            is: value => value < 0,
            then: Yup.string().required('Policy name is required'),
            otherwise: Yup.string().default(''),
        }),
        isCollectors: Yup.boolean().required(),
        isMuseums: Yup.boolean().required(),
        isDealersStock: Yup.boolean().required(),
        isCollectorPolicyConfirmed: Yup.boolean().when('isCollectors', {
            is: true,
            then: Yup.boolean().oneOf(
                [true],
                'Confirmation that the policy holder is not a commercial entity trading in art and antiques is required'
            ),
            otherwise: Yup.boolean().default(false),
        }),
        // policyInceptionDate: Yup.string().required('Policy date is required'),
        clientType: Yup.string().required('Client type is required'),
        businessName: Yup.lazy(val => {
            if ((checkIsCollectors === true || checkIsMuseums === true || checkIsDealersStock === true) &&
                checkCountryUk === false && clientType === 'limited-company') {
                return Yup.string().required('Business name is required')
            } else {
                return Yup.string()
            }
        }),
        businessId: Yup.lazy(val => {
            if (clientType === 'limited-company') {
                if (checkIsCollectors === true || checkIsMuseums === true || checkIsDealersStock === true) {
                    if (checkCountryUk === true) {
                        return Yup.string().required('Business name is required')
                    } else {
                        return Yup.string()
                    }
                } else {
                    return Yup.string().required('Business name is required')
                }
            } else {
                return Yup.string()
            }
        }),
        tradingName: Yup.string().when('clientType', {
            is: 'sole-trader',
            then: Yup.string().required('Trading name is required'),
            otherwise: Yup.string(),
        }),
        addressType: Yup.string().required('Address type is required'),
        addressLine1: Yup.string().required('Address is required'),
        addressLine2: Yup.string(),
        lat: Yup.string(),
        lng: Yup.string(),
        city: Yup.string().required('City/Town is required'),
        postcode: Yup.string().required('Postcode is required'),
        clientNames: Yup.array().when('clientType', {
            is: 'limited-company',
            then: Yup.array(),
            otherwise: Yup.array().of(Yup.object().shape({
                title: Yup.string().required('Title is required'),
                firstName: Yup.string().required('First name is required').matches(
                    /^[^0-9]+$/,
                    { message: 'The first name should not contain numbers' }),
                surname: Yup.string().required('Surname is required').matches(
                    /^[^0-9]+$/,
                    { message: 'The surname should not contain numbers' }),
                dateOfBirth: Yup.string().nullable().test(
                    'DOB', 'Invalid Date of birth: ${value}',
                    value => {
                        return (value === null) ||
                            ((moment().diff(moment(value, 'DD/MM/YYYY', true), 'years') >= 18) &&
                                (moment().diff(moment(value, 'DD/MM/YYYY', true), 'years') <= 100))
                    }),
            })),
        }),
        countryId: Yup.number().nullable().when(['isCollectors', 'isMuseums', 'isDealersStock'], {
            is: (isCollectors, isMuseums, isDealersStock) => isCollectors || isMuseums || isDealersStock,
            then: Yup.number().required('Country is required'),
            otherwise: Yup.number().default(null),
        }),
    }),

    handleSubmit: (values, { props, setSubmitting }) => {
        let content = {
            'quote': {
                'policyTypeId': Math.abs(values.policyTypeId),
                'policyCategoryId': Math.abs(values.policyCategoryId),
                'policyName': values.policyName,
                'isCollectors': values.isCollectors,
                'isMuseums': values.isMuseums,
                'isDealersStock': values.isDealersStock,
                'isCollectorPolicyConfirmed': values.isCollectorPolicyConfirmed,
                // 'policyInceptionDate': values.policyInceptionDate,
            },
            'client': {
                'clientType': (values.clientType !== 'individual') ?
                    ((values.clientType !== 'limited-company') ? 2 : 1) :
                    0,
                'businessName': (values.businessName && values.clientType === 'limited-company') ?
                    values.businessName :
                    `${values.clientNames[0].firstName} ${values.clientNames[0].surname}`,
                'businessId': (values.clientType === 'limited-company') ? values.businessId : '',
                'tradingName': (values.clientType === 'sole-trader') ? values.tradingName : '',
                'addressType': values.addressType,
                'addressLine1': values.addressLine1,
                'addressLine2': values.addressLine2,
                'lat': values.lat,
                'lng': values.lng,
                'city': values.city,
                'postcode': values.postcode,
                'clientNames': values.clientNames,
                'countryId': values.countryId,
            },
        }
        props.setStep00(content)
    },

})(Step00FormHTML)

export default Step00Form



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step00/Step00.tsx